<template>
  <v-dialog
    max-width="500"
    v-model="addTriggerDialog">
    <AddTrigger
      v-if="addTriggerDialog"
      :template_id="userEditObj.id"
      context="template"
      v-on:triggerupdated="triggerUpdated"
      v-on:close="addTriggerDialog = false" />
  </v-dialog>
  <v-alert
    class="mx-3"
    type="info"
    dense
    text
    variant="tonal"
    style="margin-right: 0px !important; margin-left: 0px !important">
    Triggers allow you to do various actions when any scene using this template
    is live.
  </v-alert>
  <v-card
    v-for="(trigger, index) in userEditObj.default_triggers"
    :key="index"
    style="
      background: var(--v-navBarBackground-base);
      border-radius: 4px;
      overflow-y: hidden;
      display: flex;
      justify-content: start;
      align-items: center;
      align-content: center;
      height: 90px;
    "
    class="mb-3"
    flat>
    <v-img
      style="width: 40px; background: #2d2d2d; border-radius: 5px"
      height="100%"
      width="40"
      muted
      loop
      loading="lazy"
      :src="state.$ident + findFirstAssetFrom(trigger.vars[0].value.value)" />

    <v-card
      style="background: var(--v-navBarBackground-base)"
      width="400px"
      flat>
      <v-card-title>
        {{ trigger.name }}
        <v-spacer />
        <v-btn
          dark
          @click="deleteTrigger(index)"
          small
          variant="flat"
          class="mr-2"
          style="background-color: var(--inner-background)">
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Starts scene with ID {{ trigger.vars[0].value.value }}
      </v-card-subtitle>
    </v-card>
  </v-card>
  <div
    class="mt-2"
    style="display: flex; justify-content: space-between; align-content: end">
    <v-spacer />
    <v-btn
      class="mb-2"
      @click="addTriggerDialog = true"
      block
      variant="tonal">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import AddTrigger from '../../Shared/AddTrigger.vue';
import { deluge } from '@/stores/deluge.js';
import { state } from '../../../stores/deluge';

// And this?
import { getCopyOfTemplate } from '../utils/templateUtils';
import { $http } from '../../../stores/http';
import { getThumbnailForScene } from '../../../utils/thumbnails.js';
const addTriggerDialog = ref(false);

const props = defineProps(['userEditObj']);

async function deleteTrigger(triggerIndex) {
  try {
    const data = await $http(
      'DELETE',
      '/v2/delete_template_trigger?template_uid=' +
        props.userEditObj.uid +
        '&trigger_index=' +
        triggerIndex
    );
    triggerUpdated(JSON.parse(data));
  } catch (error) {
    console.log(error);
  }
}

function triggerUpdated(newTemplateData) {
  deluge.templates[props.userEditObj.uid] = newTemplateData;
  // This seems interesting considering the refactor. Should this be happening? - KB 13/04/2023
  props.userEditObj = getCopyOfTemplate(state, props.userEditObj.uid);
}

function findFirstAssetFrom(sceneID) {
  // Find the Scene
  let scene = null;

  for (const itemID in deluge.items) {
    const item = deluge.items[itemID];

    if ('scene_name' in item && item['id'] === sceneID) {
      scene = item;
      break;
    }
  }

  if (scene) {
    const r = getThumbnailForScene(scene, deluge);
    return r.src || '/noAssetFound';
  }

  return '/noAssetFound';
}
</script>
